const filterByProject = (data, projectName) => data.filter(object => {
    if (!object.remark) {
        return
    }
    return object.remark.toLowerCase() === projectName.toLowerCase() && object.status
});
export default filterByProject;